import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    FlatList,
    Text
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";

import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import Filters from "./Filters";
import ProductDetails from "./ProductDetails";
import CheckOut from "./CheckOut";
import FeaturedItem from "../components/FeaturedItem";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;
const imgMenu2 = require("../images/orderNow/imageMenu.png");
const closeIcon = require("../images/Commons/closeIcon.png");
const giftIcon = require("../images/orderNow/gift.png");
const backIcon = require("../images/orderNow/backArrow.png");
const basketItems = [];
let lastItemUpdated = [];

class OrderNow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            consumerBrands: [],
            products: [],
            showCheckout: false,
            showProductsDetails: false,
            productID: '',
            showFilters: false,
            consumerBrandFilter: '',
            categoryFilter: '',
            consumerBrandName: '',
            selectedFilter: '',
            isOffers: false,
            isBestSellers: false,
            isAdv: false,
            isAdvProducts: [],
            isFeaturedItems: false,
            searchText: '',
            filtersSelected: 0,
            pharmaceuticalFilters: '',
            isSearch: false,
            searched: false,
            itemsNo: 0,
            isSelected: false,
            allFilters: [],
            productsLen: 0,
            brands: [],
            isOther: false,
            updatedItem: [],
            orderResponse: [],
            existedItem: [],
            isDesktop: false,
            currItem: {},
            selectedProductIndex: -1,

        };
    }
    Pressables = {};

    scrollToIndex = (flatListRef, index) => {
        // flatListRef.scrollToIndex({
        //     index: index,
        //     animated: false, // Optional: enables smooth scrolling animation
        // });
    };

    async componentDidMount() {
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'OrderNow',
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'Order Now', window.location.pathname);
        }
        this.setState({ searchText: this.props.searchText || '' });

        await this.loadData();

        let consumerBrandFilter = this.state.consumerBrandFilter;
        if (!Array.isArray(consumerBrandFilter)) {
            consumerBrandFilter = consumerBrandFilter ? [consumerBrandFilter] : [];
            this.setState({ consumerBrandFilter });
        }
        let categoryFilter = this.state.categoryFilter;
        if (!Array.isArray(categoryFilter)) {
            categoryFilter = categoryFilter ? [categoryFilter] : [];
            this.setState({ categoryFilter });
        }
        let pharmaceuticalFilters = this.state.pharmaceuticalFilters;
        if (!Array.isArray(pharmaceuticalFilters)) {
            pharmaceuticalFilters = pharmaceuticalFilters ? [pharmaceuticalFilters] : [];
            this.setState({ pharmaceuticalFilters });
        }
    }

    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    handleBackButton = (event) => {

        // Handle back button press - close product details
        if (event.state.page === 'ProductDetails') {
            // this.scrollToIndex(this.productsFlatList, event.state.index);

        } else if (this.props.showOrderNow) {
            this.props.showOrderNow(false);
        }

        window.history.pushState({
            page: 'OrderNow',
        }, 'Order Now', window.location.pathname);

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'OrderNow' || event.state.page === 'ProductDetails') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'Order Now', window.location.pathname);
        }
    }

    checkout() {
        this.setState({ showCheckout: true });
        if (this.props.self) {
            this.props.self.setState({ style: { opacity: 0.5 } });
        }
    }

    loadData = async () => {
        if (!this.props.searchText) {
            loaderHandler.showLoader(STRINGS.loading, this);
        } else {
            console.log('Searching for:', this.props.searchText, 'products:', this.props.products);
        }
        await this.updateItems();
        const allFilters = this.props.allFilters;
        if (allFilters) {
            this.setState({ allFilters });
        }
        const consumerBrandFilter = this.props.consumerBrandFilter;
        if (consumerBrandFilter) {
            this.setState({ consumerBrandFilter });
        }
        const consumerBrandName = this.props.consumerBrandName;
        if (consumerBrandName) {
            this.setState({ consumerBrandName });
        }
        const filtersSelected = this.props.filtersSelected;
        if (filtersSelected) {
            this.setState({ filtersSelected });
        }
        const isOffers = this.props.isOffers;
        if (isOffers) {
            this.setState({ isOffers: true });
        }
        const isBestSellers = this.props.isBestSellers;
        if (isBestSellers) {
            this.setState({ isBestSellers: true });
        }
        const isFeatured = this.props.isFeatured;
        if (isFeatured) {
            this.setState({ isFeaturedItems: true });
        }
        const categoryFilter = this.props.categoryFilter;
        if (categoryFilter) {
            this.setState({ categoryFilter });
        }
        const pharmaceuticalFilters = this.props.pharmaceuticalFilters;
        if (pharmaceuticalFilters) {
            this.setState({ pharmaceuticalFilters });
        }
        const isAdv = this.props.isAdv;
        if (isAdv) {
            this.setState({ isAdv: true });
        }
        const isAdvProducts = this.props.isAdvProducts;
        if (isAdvProducts) {
            this.setState({ isAdvProducts });
        }
        let brandsResp = await ServerOperations.getBrands();

        let productsResp = this.props.products || [];
        {
            this.state.isOffers && (
                productsResp = await ServerOperations.getOffers()
            )
        }
        {
            this.state.isBestSellers && (
                productsResp = await ServerOperations.getBestSellers()
            )
        }
        {
            this.state.isFeaturedItems && (
                productsResp = await ServerOperations.getFeaturedItems()
            )
        }
        {
            this.state.isAdv && (
                productsResp = this.state.isAdvProducts
            )
        }
        console.log('allFilters:', allFilters);
        if ((!productsResp || productsResp.length === 0 || allFilters?.length > 0) && !this.props.searchText) {
            this.updateProducts(allFilters);
        } else {
            loaderHandler.hideLoader();
        }
        this.setState({ consumerBrands: brandsResp, products: productsResp, productsLen: productsResp.length, brands: this.state.allFilters, consumerBrandName });

    }

    updateItems = async (item) => {
        const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
        console.log('Items in basket:', itemsInBasket);
        if (itemsInBasket) {
            try {
                const parsedItems = JSON.parse(itemsInBasket);
                const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
                this.setState({ itemsNo: parsedItems.length, orderResponse: orderResp.ITEMS || [] });
            } catch (e) {
                // Commons.removeFromAS(Constants.ITEMS_IN_BASKET);
                console.log('Failed to parse ITEMS_IN_BASKET:', e);
                this.setState({ itemsNo: 0 });
            }
        } else {
            this.setState({ itemsNo: 0 });
        }
    }


    filtersDistribution = (filters = this.state.allFilters) => {
        const pharmaceuticalFilters = [];
        const categoryFilter = [];
        const consumerFilter = [];

        filters.forEach((filter) => {
            if (filter.startsWith('PH-')) {
                pharmaceuticalFilters.push(filter);
            } else if (filter.startsWith('CTG-')) {
                categoryFilter.push(filter);
            } else {
                consumerFilter.push(filter);
            }
        });
        return { consumerFilter, categoryFilter, pharmaceuticalFilters };
    }

    updateProducts = async (filters = this.state.allFilters) => {
        loaderHandler.showLoader(STRINGS.loading, this);
        const { consumerFilter, categoryFilter, pharmaceuticalFilters } = this.filtersDistribution(filters);
        let productsResp = await ServerOperations.getProducts('', consumerFilter, categoryFilter, pharmaceuticalFilters);
        this.setState({ products: productsResp, brands: this.state.allFilters });
        loaderHandler.hideLoader();
    };


    calculateOrderPrice = () => {

    }


    renderMobile() {
        scale = width / 420;
        if (this.state.showFilters) {
            return <Filters self={this}
                applyFilters={(allFilters, consumerBrandName, cancel = false) => {
                    if (cancel) {
                        this.setState({ showFilters: false });
                        return;
                    }
                    console.log('Applying filters from OrderNow:', allFilters, consumerBrandName);
                    this.setState({ showFilters: false, allFilters, consumerBrandName }, () => {
                        this.updateProducts(this.state.allFilters);
                    });
                }}
                allFilters={this.state.allFilters}
                consumerChosenFilters={this.state.consumerBrandFilter}
                pharmaChosenFilter={this.state.pharmaceuticalFilters}
                categChosenFilter={this.state.categoryFilter}
                productsLen={this.state.productsLen}
                filtersNames={this.state.consumerBrandName}
                brands={this.state.allFilters}
            />;
        }

        if (this.state.showProductsDetails) {
            // return <View style={{ position: 'absolute', width, height, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
            //     <ProductDetails self={this} productID={this.state.productID}
            //         showProductsDetails={(show) => { this.setState({ showProductsDetails: show, }) }} />
            // </View>
        }

        return (
            [
                Commons.loadFonts(this, false),
                (
                    this.state.showProductsDetails &&
                    <View style={{ position: 'absolute', flex: 1, minHeight: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                        <ProductDetails self={this} productID={this.state.productID}
                            showProductsDetails={(show) => { this.setState({ showProductsDetails: show, }) }} />
                    </View>
                ),
                <View style={styles.container}>
                    {Commons.renderAppHeader('', this, false, this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)}
                    {this.renderPart1Mobile()}

                    {/* {this.state.showProductsDetails &&
                    <View style={{ position: 'absolute', width, height, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                        <ProductDetails self={this} productID={this.state.productID}
                            showProductsDetails={(show) => { this.setState({ showProductsDetails: show, }) }} />
                    </View>
                } */}

                    <ScrollView
                        ref={ref => this.mainScrollView = ref}
                        contentContainerStyle={{ backgroundColor: AppStyles.desktopBackgroundColor, width }}
                        scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                        <View style={{ flex: 1, }}>

                            {this.renderPart2Mobile()}
                            {this.renderPart3Mobile()}
                        </View>
                    </ScrollView>
                    {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                    {this.state.isOther && Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                    {!this.state.isOther && Commons.renderAppFooter({}, this, '', '#52C0EE', '', '', '')}
                </View >
            ]
        );
    }

    render() {
        this.title = 'Order Now';
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            width = Dimensions.get("window").width;
            styles = this.styles();
            return this.renderMobile();
        } else if (window.location.pathname !== '/ClientHomePage') {
            window.location = './ClientHomePage';
            return null;
        } else {
            this.props.self.currentComponent = this;
        }
        width = Commons.getDesktopWidth();
        height = Commons.getDesktopHeight();
        styles = this.styles();

        if (this.state.showFilters) {
            return <Filters self={this}
                applyFilters={(allFilters, consumerBrandName, cancel = false) => {
                    if (cancel) {
                        this.setState({ showFilters: false });
                        return;
                    }
                    console.log('Applying filters from OrderNow:', allFilters, consumerBrandName);
                    this.setState({ showFilters: false, allFilters, consumerBrandName }, () => {
                        this.updateProducts(this.state.allFilters);
                    });
                }}
                showFilters={(show) => { this.setState({ showFilters: show, }) }}
                consumerChosenFilters={this.state.consumerBrandFilter}
                pharmaChosenFilter={this.state.pharmaceuticalFilters}
                categChosenFilter={this.state.categoryFilter}
                productsLen={this.state.productsLen}
                allFilters={this.state.allFilters}
                filtersNames={this.state.consumerBrandName}
                brands={this.state.allFilters}
            />;
        }

        return (
            [
                this.state.showCheckout && (
                    <View style={{ position: 'absolute', width, height, zIndex: 100, marginLeft: 2.5 }}>
                        <CheckOut self={this} showCheckout={(show) => {
                            this.setState({ showCheckout: show });
                            if (!show) {
                                this.props.self.setState({ style: { opacity: 1 } });
                            }
                        }}
                        />
                    </View>
                )
                , <View style={[styles.container, {
                    paddingHorizontal: 15,
                    backgroundColor: AppStyles.desktopBackgroundColor,
                }]}>
                    {Commons.renderAppHeader('', this, '', this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)}
                    {this.renderPart1Mobile()}

                    {this.state.showProductsDetails &&
                        <View style={{ position: 'absolute', flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                            <ProductDetails self={this} productID={this.state.productID}
                                showProductsDetails={(show) => {
                                    this.setState({ showProductsDetails: show, products: this.state.products.slice() });
                                }} />
                        </View>
                    }

                    <ScrollView style={{
                        height: height - 120,
                    }}
                        contentContainerStyle={{ flexGrow: 1 }}
                        ref={ref => this.mainScrollView = ref}
                        scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                        <View style={{ flex: 1 }}>
                            {this.renderPart2Mobile()}
                            {this.renderPart3Mobile()}
                        </View>
                    </ScrollView>
                </View >
            ]
        );
    }


    renderPart1 = () => {
    }

    renderPart1Mobile = () => {
        const { showOrderNow } = this.props;
        return (
            <View style={{ flexDirection: 'row', gap: 6, alignSelf: 'stretch', height: 40, marginHorizontal: 20 }}>
                {showOrderNow ? (
                    <TouchableOpacity
                        onPress={() => {
                            this.setState({ isOffers: false, isBestSellers: false, isFeaturedItems: false, consumerBrandName: '' });
                            showOrderNow(false);
                        }}
                        style={{ alignItems: 'center', gap: 8, flexDirection: 'row', borderRadius: 10, height: 18, marginTop: 8, marginRight: 12 }}>
                        <Image source={backIcon} style={{ width: 17, height: 17 }} />
                    </TouchableOpacity>
                ) : null}
                {this.state.consumerBrandName && (
                    <View style={{ width: width - 160, marginTop: 3 }}>
                        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
                            {this.state.consumerBrandName.map((brandName, idx) => (
                                <View key={idx} style={{
                                    alignItems: 'center', gap: 8,
                                    flexDirection: 'row', borderRadius: 10,
                                    marginHorizontal: idx > 0 ? 8 : null, paddingHorizontal: 13, height: 26,
                                    backgroundColor: '#FFF'
                                }}>
                                    <Text style={[AppStyles.showFilterText, { lineHeight: 14, }]}>{brandName}</Text>
                                    <TouchableOpacity
                                        onPress={() => {
                                            const updatedBrandNames = this.state.consumerBrandName.filter((_, i) => i !== idx);
                                            const updatedAllFilters = this.state.allFilters.filter((_, i) => i !== idx);
                                            // const brandFilter = this.state.consumerBrandFilter.filter((_, i) => i !== idx);
                                            // const categoryFilter = this.state.categoryFilter.filter((_, i) => i !== idx);
                                            // const pharmaCateg = this.state.pharmaceuticalFilters.filter((_, i) => i !== idx);
                                            this.updateProducts(updatedAllFilters);
                                            this.setState({
                                                // consumerBrandFilter: brandFilter,
                                                // categoryFilter: categoryFilter,
                                                // pharmaceuticalFilters: pharmaCateg,
                                                consumerBrandName: updatedBrandNames,
                                                allFilters: updatedAllFilters,
                                            });
                                        }}
                                    >
                                        <Image source={closeIcon} style={{ height: 8, width: 8, tintColor: Styles.appColor1 }}></Image>
                                    </TouchableOpacity>
                                </View>
                            ))}
                        </ScrollView>
                    </View>
                )}
                {this.state.searched && (
                    <View style={{ alignItems: 'center', justifyContent: 'center', }}>
                        <Text style={[AppStyles.searchedText]}>" {this.state.searchText} "</Text>
                    </View>
                )}
                <TouchableOpacity style={{ justifyContent: 'center', alignItems: 'center', position: 'absolute', right: 0, top: 8, flexDirection: 'row', gap: 10 }}
                    onPress={() => {
                        this.setState({ showFilters: true, productsLen: this.state.products.length })
                    }}
                >
                    <Text style={[AppStyles.productLenText, { marginBottom: 5 }]}>{this.state.products.length} {STRINGS.products_Items}</Text>
                    <Image source={imgMenu2} style={{ width: 19, height: 19.354 }} />
                </TouchableOpacity>
            </View>
        )
    }



    renderPart2 = () => {

    }



    renderPart2Mobile = () => {
        let columnNum = 2;
        if (this.state.isSearch && isMobile) {
            columnNum = 1
        } else {
            columnNum = Commons.getNumColumns();
        }

        // Helper function to pad data with dummy items for complete rows
        const getPaddedData = (originalData, columns) => {
            if (columns === 1) return originalData; // No padding needed for single column

            const data = [...originalData];
            const remainder = data.length % columns;

            if (remainder !== 0) {
                const itemsToAdd = columns - remainder;
                for (let i = 0; i < itemsToAdd; i++) {
                    data.push({
                        ID: `dummy_${i}`,
                        isDummy: true
                    });
                }
            }

            return data;
        };

        const paddedData = getPaddedData(this.state.products.slice(0, 400), columnNum);

        return (
            <View style={{ justifyContent: 'center', alignItems: 'center', backgroundColor: AppStyles.desktopBackgroundColor }}>
                {(!this.state.isSearch || !isMobile) && (
                    <FlatList
                        style={[{ flex: 1 }, !isMobile && { width: width - 60 }]}
                        ref={ref => { this.productsFlatList = ref; }}
                        data={paddedData}
                        keyExtractor={(item, index) => item.isDummy ? `dummy_${index}` : item.ID}
                        renderItem={({ item, index }) => {
                            // if (item.isDummy) {
                            //     return <View style={{ flex: 1 }} />; // Empty placeholder
                            // }
                            return this.renderFeaturedItem(item, index);
                        }}
                        contentContainerStyle={{ paddingVertical: 8 }}
                        numColumns={columnNum}
                        columnWrapperStyle={{ justifyContent: 'space-between', marginBottom: isMobile ? 0 : 16 }}
                        key={`flatlist-columns-${columnNum}`}
                        removeClippedSubviews
                        maxToRenderPerBatch={10}
                        windowSize={10}
                        showsVerticalScrollIndicator={false}

                    />
                )}

                {this.state.isSearch && isMobile && (
                    <FlatList
                        style={[{ width }, !isMobile && { marginLeft: 60 }]}
                        ref={ref => { this.productsFlatList = ref; }}
                        data={this.state.products.slice(0, 400)}
                        keyExtractor={(item, index) => item.ID}
                        renderItem={({ item, index }) => this.renderFeaturedItem(item, index)}
                        contentContainerStyle={{ paddingVertical: 8, alignItems: 'flex-start', justifyContent: 'flex-start' }}
                        numColumns={1}
                        removeClippedSubviews
                        maxToRenderPerBatch={10}
                        windowSize={10}
                        showsVerticalScrollIndicator={false}
                    />

                )}

            </View>
        )
    }

    renderFeaturedItem = (item, index) => {
        return (
            <View style={[{ justifyContent: 'center', alignItems: 'center' }, !item.isDummy && isMobile && { backgroundColor: '#FFF' }]}>
                <FeaturedItem
                    self={this}
                    item={item}
                    orderResponse={this.state.orderResponse}
                    itemsNo={(show) => { this.setState({ itemsNo: show }) }}
                    isSearch={this.state.isSearch}
                    margin={this.state.isSearch ? 0 : 10}
                    showProductsDetails={(show) => {
                        this.setState({ showProductsDetails: show, productID: item.ID });
                        if (typeof window !== 'undefined' && window.location.pathname) {
                            window.history.pushState({
                                page: 'ProductDetails',
                                timestamp: Date.now(),
                                index: index
                            }, 'Product Details', window.location.pathname);
                        }
                    }} />
            </View>
        )
    }




    getItemBonus = async (itemID) => {
    }


    renderPart3 = () => {

    }

    renderPart3Mobile = () => {

    }

    renderPart4 = () => {

    }

    renderPart4Mobile = () => {

    }

    renderPart5Mobile = () => {

    }



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor,
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });
}



export default OrderNow;
